export const DESIGNER_URL_STORAGE_BASE_KEY = 'guide.designer.urls';

export function generateDesignerLastUrlUserSettingsKey (subscriptionId, appId) {
    // this key doesn't match some of the more modern formatting we use in user settings because its ancient
    return `${DESIGNER_URL_STORAGE_BASE_KEY}.${subscriptionId}.${appId}`;
}

export function generateAdoptDesignerLastUrlUserSettingsKey (subscriptionId, appId) {
    return `${subscriptionId}:${appId}--lastDesignerUrl`;
}
